import { Directive, OnInit, Input, ElementRef, Renderer2, SimpleChanges, OnChanges } from '@angular/core';

@Directive({
    selector: '[isMandatory]',
    standalone: false
})
export class MandatoryFieldsDirective implements OnInit, OnChanges {
    @Input() fieldName: number;
    @Input() RequiredList: any[] = [];

    constructor(private elementRef: ElementRef,
        private renderer: Renderer2, ) { }

    ngOnInit() {
        if (this.RequiredList.length) {
            this.checkRequired();
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['RequiredList']) {
            this.checkRequired();
        }
    }

    checkRequired() {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'inline');
        let reqObj = this.RequiredList.find(o => o.Name == this.fieldName);
        let reqArr = this.RequiredList.filter(o => o.Name == this.fieldName);
        if (reqArr && (reqArr.length > 1)) {
            reqObj = reqArr[reqArr.length - 1];
        }
        if (reqObj) {
            if (!reqObj.Required)
                this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
            else
                this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'inline');
        } else {
            this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
        }
    }
}